export default __webpack_public_path__ + "static/media/arrow-right.9c65af5b.svg";